import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import LectureItem from '../../components/LectureItem'
import PersonalCard from '../../components/PersonalCard'
import ProfileCard from '../../components/ProfileCard'
import BasicLayout from '../../layouts/BasicLayout'
import { dispatch, RootState, select, store } from '../../store'
import styles from './profile-page.scss'

const cx = classnames.bind(styles)

interface IProps extends
  Partial<ReturnType<typeof mapState>>,
  RouteComponentProps<any> {

}

class ProfilePage extends React.Component<IProps> {
  public state = {
    editing: false
  }
  public handleEditingToggle = () => {
    this.setState({ editing: !this.state.editing })
  }
  /**
   * handleProfileChange
   */
  public handleProfileChange = (property: string, value: string) => {
    dispatch.users.updateProfile({
      [property]: value
    })
  }
  public fetchData = (props: IProps) => {
    const rootState = store.getState()
    const { match } = props
    const userId = match.params.userId
    const user = userId ? select.users.getById(rootState, userId) : null
    if (user === null) {
      dispatch.users.fetchUsers([userId])
    }
  }
  public componentWillReceiveProps = (nextProps: IProps) => {
    this.fetchData(nextProps)
  }
  public componentDidMount = () => {
    this.fetchData(this.props)
  }
  public render() {
    const rootState = store.getState()
    const { editing } = this.state
    const { match } = this.props
    const userId = match.params.userId
    const createdLectureIds = select.lectures.getCreatedLectureIds(rootState, userId)
    return (
      <BasicLayout>
        <div>
          <div className={cx('page-Profile__main')}>
            <div className={cx('container')}>
              {
                editing ? (
                  <PersonalCard userId={userId} theme="primary" deviceType="md" onConfirm={this.handleEditingToggle} />
                ) : (
                    <ProfileCard userId={userId} theme="primary" deviceType="md" onEdit={this.handleEditingToggle} />
                  )
              }
            </div>
          </div>
          <div className={cx('page-Profile__lessons')}>
            <div className={cx('container')}>
              <h3 className={cx('page-Profile__section-heading')}>開設講座</h3>
              <div className={cx('lecture-group')}>
                <div className={cx('row')}>
                  {
                    createdLectureIds.map(lectureId => (
                      <div key={lectureId} className={cx('col-lg-4', 'col-md-6')}>
                        <LectureItem lectureId={lectureId} />
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </BasicLayout>
    )
  }

}

const mapState = ({ lectures, users }: RootState) => {
  const currentUser = firebase.auth().currentUser
  return {
    lectures,
    currentUserId: currentUser ? currentUser.uid : null,
  }
}

export default connect(mapState)(ProfilePage)



// WEBPACK FOOTER //
// ./src/pages/ProfilePage/index.tsx